/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authCreatePosts.defs.js'
export * as $defs from './authCreatePosts.defs.js'
